// MSAL configuration for Entra SSO
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID ?? "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    // sessionStorage (not localStorage): tokens are cleared when the tab/browser
    // closes and are not shared across tabs — already a more careful posture than
    // the localStorage default.
    //
    // OS-1683 F4 asked to move to "memoryStorage" to put tokens fully out of web
    // storage. We attempted that and it is INCOMPATIBLE with this app's auth flow:
    // memoryStorage forbids redirect-based login (in_mem_redirect_unavailable),
    // and the popup-based alternative does not work under @azure/msal-browser
    // 5.10.x — the popup completes auth (lands on .../#code=...) but the library
    // never posts the result back to the opener / closes the popup, so login
    // hangs. This is a known MSAL v5 popup regression, not a config error here.
    // Decision (June 1 2026): keep sessionStorage + redirect login (working), and
    // ship the CSP hardening from the same finding. The memoryStorage move is
    // deferred — see 10-Code-Review-Findings.md F4 for the full rationale and the
    // conditions under which to revisit (MSAL popup fix, or an MSAL version bump).
    cacheLocation: "sessionStorage" as const,
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_ENTRA_CLIENT_ID}/access_as_user`],
};
